import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'

import { Icon } from '@components/shared/elements'

import { isEmpty } from 'lodash'

import TOOLS from '@helpers/tools'

class FieldNameSimulator extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      nameDirt: false,
    }
  }

  componentDidMount() {
    if (!isEmpty(this.props.currentUser)) {
      let user = this.props.currentUser
      this.setState({
        name: (user.Nome) ? user.Nome : '',
      })
      this.props.onUpdateValue(user.Nome)
    }
  }

  _updateValue(value) {
    this.setState({ name: value })
    this.props.onUpdateValue(value)
  }


  render() {

    let nameValid

    if (this.state.nameDirt || this.props.showInvalid) {
      nameValid = TOOLS.fullNameValid(this.state.name) ? 'is-valid' : 'has-error'
    }

    return (
      <div>
        <div className={`field-group ${nameValid === 'is-valid' && 'is-valid'} ${nameValid === 'has-error' && 'has-error'}`}>
          <label>
            <input
              className='mb0'
              type='text'
              value={this.state.name}
              onChange={(event) => this._updateValue(event.target.value)}
              onBlur={() => this.setState({ nameDirt: true })}
              maxLength='70'
              placeholder='Nome completo'
            />
            <div className='text-small text-error ml1 mt1 text-left'>Preencha seu nome completo, por favor</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon iconType='far' icon='user' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>

      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...USER_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldNameSimulator)



// WEBPACK FOOTER //
// ./src/components/children/simulator/FieldNameSimulator.js